import ForgotPassword from "../../components/auth/password/ForgotPassword.tsx";

function ForgotPasswordPage() {
    return (
        <>
            <ForgotPassword />
        </>
    );
}

export default ForgotPasswordPage;